import dayjs from "dayjs"

const workDuration = (startTime: string | undefined, endTime: string | undefined) => {
  if (!startTime || !endTime) return dayjs().hour(1).minute(0)
  const duration = dayjs(endTime).diff(dayjs(startTime), 'minute')
  if (duration > 24*60) return dayjs().hour(23).minute(59)
  return dayjs().hour(Math.floor(duration / 60)).minute(duration % 60)
}

export default workDuration
